"use strict";
/* globals module */
/**
 * @module languageRoute
 * @description Baasic Language Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Language Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var _1 = require("./");
var contracts_1 = require("../../core/contracts");
var LanguageRoute = /** @class */ (function (_super) {
    tslib_1.__extends(LanguageRoute, _super);
    function LanguageRoute(appOptions, languageBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.languageBatchRoute = languageBatchRoute;
        _this.findRoute = 'lookups/language/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.createRoute = 'lookups/language';
        _this.getRoute = 'lookups/language/{id}/{?embed,fields}';
        _this.updateRoute = 'lookups/language/{id}';
        _this.deleteRoute = 'lookups/language/{id}';
        return _this;
    }
    Object.defineProperty(LanguageRoute.prototype, "batch", {
        get: function () {
            return this.languageBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing company properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain company subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the company property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example languageRoute.find({searchQuery: '<search-phrase>'});
     **/
    LanguageRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example languageRoute.create();
     **/
    LanguageRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id Company id which uniquely identifies resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example languageRoute.get();
     **/
    LanguageRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    LanguageRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    LanguageRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    LanguageRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.LanguageBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.LanguageBatchRoute !== "undefined" && _1.LanguageBatchRoute) === "function" ? _b : Object])
    ], LanguageRoute);
    return LanguageRoute;
}(common_1.BaseRoute));
exports.LanguageRoute = LanguageRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
